<form [formGroup]="addressForm()" class="ap-dutch-address ap-grid ap-gap-2 ap-grid-cols-1 ap-grid-margin-fix">
    <section class="ap-grid ap-gap-2 ap-gap-gt-sm-5 ap-grid-cols-2 ap-grid-cols-gt-sm-3">
        <ap-zipcode-input
            class="ap-col-span-sm-2"
            [label]="'address.postalCode.label' | apContent"
            formControlName="postalCode"
            [messages]="postalCodeErrors"
            autocomplete="section-dutch-address postal-code"
            data-testid="dutch-address-zipcode"
        >
        </ap-zipcode-input>

        <ap-input
            [label]="houseNumberLabel | apContent"
            formControlName="houseNumber"
            [messages]="houseNumberErrors"
            autocomplete="section-dutch-address address-line1"
            data-testid="dutch-address-house-number"
        >
        </ap-input>

        <ap-input
            [label]="'address.houseNumberSuffix.label' | apContent"
            name="houseNumberSuffix"
            formControlName="houseNumberSuffix"
            [messages]="houseNumberSuffixErrors"
            autocomplete="section-dutch-address address-line2"
            data-testid="dutch-address-house-number-suffix"
        >
        </ap-input>
    </section>

    @if (retrieved) {
        <ap-panel type="primary">
            <div ap-panel-body>
                <p data-testid="dutch-address-result-text">
                    <ap-content key="address.result.found"></ap-content>
                </p>
                <ap-dutch-address-read-only [address]="addressForm().getRawValue()"></ap-dutch-address-read-only>
            </div>
        </ap-panel>
    }

    @if (errorMessage) {
        @if (!showManualInput) {
            <ap-notification status="info" data-testid="dutch-address-notification">
                <ap-content [key]="errorMessage"></ap-content>
            </ap-notification>
        } @else {
            <section class="ap-grid ap-gap-2 ap-grid-cols-1">
                @if (!retrieved && errorMessage) {
                    <ap-notification status="info" data-testid="dutch-address-notification">
                        <ap-content [key]="errorMessage"></ap-content>
                    </ap-notification>
                }

                <div class="ap-grid ap-gap-2 ap-grid-cols-1 ap-grid-cols-md-2">
                    <ap-input
                        data-testid="streetInput"
                        [label]="'address.street.label' | apContent"
                        formControlName="street"
                        [messages]="streetErrors"
                        apDiacriticsNormalizeFormValue
                        (hasDiacritics)="onDiacriticsChange($event, 'street')"
                    >
                    </ap-input>
                    <ap-input
                        data-testid="cityInput"
                        [label]="'address.city.label' | apContent"
                        formControlName="city"
                        [messages]="cityErrors"
                        apDiacriticsNormalizeFormValue
                        (hasDiacritics)="onDiacriticsChange($event, 'city')"
                    >
                    </ap-input>
                </div>
                @if (diacriticFieldValue['street']) {
                    <ap-notification data-testid="street" status="warning">
                        <ap-content key="{{ 'address.street.diacritics.message' }}"></ap-content>
                    </ap-notification>
                }
                @if (diacriticFieldValue['city']) {
                    <ap-notification data-testid="city" status="warning">
                        <ap-content key="{{ 'address.city.diacritics.message' }}"></ap-content>
                    </ap-notification>
                }
            </section>
        }
    }
</form>
